import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/infrastructures/profile/loading';

export const Route = createFileRoute('/_private/settings/infrastructures/$id')({
  pendingComponent: Loading,
});
